'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
  language: 'en' | 'ar';
}

const SearchBar = ({
  searchQuery,
  onSearchChange,
  suggestions,
  onSuggestionClick,
  language
}: SearchBarProps) => {
  return (
    <div className="max-w-2xl mx-auto relative">
      <div className="relative">
        <Icon
          name="MagnifyingGlassIcon"
          size={20}
          variant="outline"
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-text-secondary"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={
            language === 'en' ?'Search FAQs, topics, or keywords...' :'ابحث عن الأسئلة الشائعة أو المواضيع أو الكلمات الرئيسية...'
          }
          className="w-full pl-12 pr-4 py-4 rounded-lg text-text-primary focus:outline-none focus:ring-2 focus:ring-accent"
        />
        {searchQuery && (
          <button
            onClick={() => onSearchChange('')}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-text-secondary hover:text-text-primary transition-colors duration-base"
          >
            <Icon name="XMarkIcon" size={20} variant="outline" />
          </button>
        )}
      </div>

      {/* Auto-complete Suggestions */}
      {suggestions.length > 0 && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-card rounded-lg shadow-elevated border border-border overflow-hidden z-10">
          {suggestions.map((suggestion, index) => (
            <button
              key={index}
              onClick={() => onSuggestionClick(suggestion)}
              className="w-full text-left px-4 py-3 hover:bg-muted transition-colors duration-base flex items-center gap-2"
            >
              <Icon name="MagnifyingGlassIcon" size={16} variant="outline" className="text-text-secondary" />
              <span className="text-text-primary">{suggestion}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;